import { ButtonVariantEnum } from '../../enums';
import { FunctionComponent } from 'react';
import { IconButtonType } from '../../types';
import { IconHandler } from '../../utils';

const IconButton: FunctionComponent<IconButtonType> = ({
  title,
  onClick,
  variant = ButtonVariantEnum.PRIMARY,
  noBorder = false,
  circle = false,
  className = '',
  Icon,
  ...props
}) => {
  return (
    <button
      type="button"
      className={`btn p-1 align-self-center color-hover-only btn-icon-outline-${variant} d-flex${
        circle ? ' circle' : ''
      } ${className}${noBorder ? ' no-border' : ''}`}
      onClick={onClick}
      title={title}
      {...props}
    >
      <IconHandler Icon={Icon} size={'1rem'} />
    </button>
  );
};

export default IconButton;
